import { render, staticRenderFns } from "./InputAttachFile.vue?vue&type=template&id=46a4d785&scoped=true"
import script from "./InputAttachFile.vue?vue&type=script&lang=js"
export * from "./InputAttachFile.vue?vue&type=script&lang=js"
import style0 from "./InputAttachFile.vue?vue&type=style&index=0&id=46a4d785&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a4d785",
  null
  
)

export default component.exports